/* eslint-disable */

<template>
  <div class="content billing">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <card>
            <template slot="header">
              {{ billing_title }}
            </template>
            <template>
              <div class="billing-explainer">
                {{ billingExplainer }}
              </div>
              <div class="upfront-charge">
                {{ upfront_charge }}
              </div>
              <div class="upfront-charge-caption">
                {{ upfront_charge_caption }}
              </div>
              <default-button :buttonText="checkout_button_title" :processing-click="submitting_create_checkout_session" v-on:onButtonClicked="beginCheckout" />
              <div class="charge-explainer">
                {{ charge_explainer }}
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'
  import axios from 'axios'

  export default {
    components: {
      Card,
      DefaultButton,
    },
    data: function () {
      return {
        billing_title: 'Billing',
        upfront_charge: '$0.00',
        upfront_charge_caption: 'upfront charge',
        checkout_button_title: 'ADD CARD INFORMATION',
        submitting_create_checkout_session: false,
        charge_explainer: '',
      }
    },
    methods: {
      beginCheckout () {
        this.submitting_create_checkout_session= true;

        const headers = {
          headers: {
            Authorization: `JWT ${this.$store.state.jwt.jwt}`,
          }
        }

        axios.post(this.$store.state.endpoints.billingCreateCheckoutSession, {}, headers)
          .then((response)=>{
            var stripe = Stripe('pk_live_KbEau8qXfNI28Fleob2Fee1J');

            stripe.redirectToCheckout({
              sessionId: response.data.session_id
            }).then(function (result) {
              console.log(result.error.message);
            });
          })
          .catch((error)=>{
            console.log(error);
            this.submitting_create_checkout_session = false;
          })
      }
    },
    computed: {
      billingExplainer () {
        return `Welcome aboard, ${this.$store.getters.user.first_name}! Please click the button below to securely add your credit card information:`;
      },
    },
    mounted: function () {
      this.charge_explainer = this.$store.getters.user.billing_explanation;
    },
  }
</script>